//it will add to index.html like this: <script src="https://browser.sentry-cdn.com/sentry-toolbar/latest/toolbar.min.js"></script>
export const addCdnScript = (
  src: string,
  htmlElementAnchor = document.body,
  {
    defer,
    async,
    crossOrigin,
  }: {
    defer?: boolean
    async?: boolean
    crossOrigin?: string
  } = {},
) =>
  new Promise((resolve) => {
    const cdnScriptId = `addCdnScript:${src}`

    if (document.getElementById(cdnScriptId)) {
      resolve({ isSuccess: true })

      return
    }

    const el = document.createElement('script')

    el.src = src
    el.id = cdnScriptId

    if (defer) {
      el.defer = defer
    }

    if (async) {
      el.async = async
    }

    if (crossOrigin) {
      el.crossOrigin = crossOrigin
    }

    const onLoad = () => {
      el.removeEventListener('load', onLoad)
      resolve({ isSuccess: true })
    }

    el.addEventListener('load', onLoad)

    const onReject = () => {
      el.removeEventListener('error', onReject)
      resolve({ isSuccess: false })
    }

    el.addEventListener('error', onReject)
    htmlElementAnchor.append(el)
  }).catch((error) => {
    console.error(`Error loading script: ${src}`, error)

    return { isSuccess: false }
  })
